import React from "react";
import { Paper, Typography } from "@mui/material";

// NOTIF-25 — lock-screen-style preview beside the push fields: title on
// line 1, subtitle on line 2 (empty when subtitle is blank). Memoized on
// its own {push_title, push_subtitle} slice (context.md "Previews").
// Mounting/unmounting on the push toggle (NOTIF-25 AC3) is the caller's
// job — PushStep already only renders push fields when the toggle is on.
function LockScreenPreview({ push_title, push_subtitle }) {
  return (
    <Paper
      variant="outlined"
      data-testid="lock-screen-preview"
      sx={{ p: 2, borderRadius: 3, bgcolor: "grey.900", color: "common.white", minWidth: 240 }}
    >
      <Typography variant="caption" sx={{ opacity: 0.7 }}>
        Lock screen preview
      </Typography>
      <Typography
        variant="body2"
        sx={{ fontWeight: "bold", wordBreak: "break-word" }}
        data-testid="lock-screen-preview-title"
      >
        {push_title}
      </Typography>
      <Typography
        variant="body2"
        sx={{ wordBreak: "break-word" }}
        data-testid="lock-screen-preview-subtitle"
      >
        {push_subtitle}
      </Typography>
    </Paper>
  );
}

export default React.memo(LockScreenPreview);
